@if (userLoggedIn()) {
  <div class="layout-topbar">
    <ul class="topbar-menu fade-in-down">
      <li>
        <a (click)="logout()" class="sh-u-hover-pointer">
          <i class="topbar-icon pi pi-power-off"></i>
        </a>
      </li>
      <li
        class="po-header__user-profile"
        #profile
        [ngClass]="{
          'active-topmenuitem': topbarState.activeTopbarItem === profile,
        }"
      >
        <div class="po-header__user-name">
          <span>{{ userInfo$ | async }} {{ supplierName$ | async }}</span>
        </div>
        <a
          (click)="topbarState.onTopbarItemClick($event, profile)"
          class="sh-u-hover-pointer"
        >
          <i class="pi pi-user topbar-icon"></i>
        </a>
        <ul class="fade-in-down">
          <li role="menuitem">
            <a [routerLink]="['/user-management/profile']">
              <i class="pi pi-user"></i>
              <span i18n>Profil</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
    @if (isSupplierActive$ | async) {
      <ul class="po-header__top-menu">
        <li class="po-header__top-menu__item">
          <a
            class="po-header__top-menu__item__link"
            [routerLink]="['/supplier-area/misc/business-analysis']"
            i18n
          >
            BUSINESS ANALYSEN
          </a>
        </li>
        <li class="po-header__top-menu__item">
          <a
            class="po-header__top-menu__item__link"
            [routerLink]="['/supplier-area/misc/flyer']"
            i18n
          >
            FLUGBLÄTTER
          </a>
        </li>
      </ul>
    }
  </div>
}

@if (!userLoggedIn()) {
  <div>
    <pt-public-header></pt-public-header>
  </div>
}
